export default {
  "discover_your": "உங்கள்",
  "ascendant": "லக்னம்",
  "rising_sign_analysis": "லக்னம் (ரேசிங் சைன்) பகுப்பாய்வு",
  "ascendant_description": "இது உங்கள் தன்மை, தோற்றம், வாழ்க்கைப் பாதை ஆகியவற்றை உருவாக்குகிறது; அதேவேளையில் சந்திரன் மற்றும் சூரிய ராசிகள் கால அளவிலான முன்கணிப்புகளை வழிநடத்துகின்றன.",
  "exact_time_critical_for_ascendant": "உண்மையான பிறந்த நேரம் துல்லியமான லக்னக் கணக்கீட்டுக்கு மிக முக்கியம்",
  "location_essential_for_ascendant": "துல்லியமான பிறந்த இடம் உங்கள் லக்னத்தை நிர்ணயிக்க அத்தியாவசியம்",
  "complete_ascendant_analysis": "முழுமையான லக்னம் பகுப்பாய்வு",
  "rising_sign_identification": "லக்ன ராசி அடையாளம் காண்வு",
  "personality_traits_analysis": "தன்மை பண்புகள் பகுப்பாய்வு",
  "first_impression_insights": "முதல் பார்வைப் பதிப்பு நுண்ணறிவுகள்",
  "life_path_guidance": "வாழ்க்கைப் பாதை வழிகாட்டுதல்",
  "focused_ascendant_analysis_note": "உங்கள் லக்னம் மற்றும் அதனுடன் சேர்ந்த தன்மைப் பண்புகளுக்கே திகழும் சிறப்பு பகுப்பாய்வு.",
  "pay_and_generate_analysis": "கட்டணத்தை செலுத்தி பகுப்பாய்வு உருவாக்கவும்",
  "your_rising_sign_detailed": "உங்கள் லக்ன ராசியின் விரிவான விளக்கம்",
  "personality_mask_analysis": "வெளிப்புற தன்மை முகமூடி மற்றும் வெளிப்பாடு பகுப்பாய்வு",
  "appearance_and_style_insights": "தோற்றம் மற்றும் ஸ்டைல் பற்றிய நுண்ணறிவுகள்",
  "life_approach_patterns": "வாழ்க்கை அணுகுமுறை மற்றும் நடத்தை முறைபாடுகள்",
  "sample_ascendant_analysis": "மாதிரி லக்னம் பகுப்பாய்வு",
  "sample_ascendant_description": "உங்கள் தனிப்பட்ட லக்ன அறிக்கை விரிவான நுண்ணறிவுகளுடன் இவ்வாறு இருக்கும்.",
  "rising_signs": "லக்ன ராசிகள்",
  "aries_rising": "மேஷ லக்னம்",
  "taurus_rising": "ரிஷப லக்னம்",
  "gemini_rising": "மிதுன லக்னம்",
  "cancer_rising": "கடக லக்னம்",
  "leo_rising": "சிம்ம லக்னம்",
  "virgo_rising": "கன்னி லக்னம்",
  "ascendant_analysis_processing": "உங்கள் லக்னம் பகுப்பாய்வை எங்கள் நிபுணர் ஜோதிடர்கள் தயாரித்து வருகின்றனர்.",
  "detailed_ascendant_report_pdf": "விரிவான லக்னம் அறிக்கை (PDF வடிவம்)",
  "rising_sign_characteristics": "லக்ன ராசியின் பண்புகள் & குணாதிசயங்கள்",
  "personality_presentation_insights": "தன்மை வெளிப்பாடு பற்றிய நுண்ணறிவுகள்",
  "first_impression_analysis": "முதல் பார்வை & சமூக முகவருகை பகுப்பாய்வு",
  "life_approach_guidance": "வாழ்க்கை அணுகுமுறை & நடத்தை வழிகாட்டுதல்",
  "your_ascendant_analysis_status": "உங்கள் லக்னம் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் பகுப்பாய்வு செயலாக்கத்தில் உள்ளது",
  "analysis_processing_message": "உங்கள் தனிப்பட்ட லக்னம் பகுப்பாய்வில் எங்கள் நிபுணர் ஜோதிடர்கள் பணிபுரிந்து வருகின்றனர்."
}
